import { environment } from '@masar/env/environment';
import { MNMConfig } from 'mnm-webapp';

export const mnmWebAppConfig: MNMConfig = {
    oauthConfig: {
        claimsUrl: environment.apiUrl + '/claims',
        oauthUrl: environment.apiUrl,
    },
    modal: {
        animations: {
            dialogEnterAnimation: {
                keyframes: [
                    { transform: 'scale(0.7)', opacity: 0.5 },
                    { transform: 'scale(1)', opacity: 1 },
                ],
                options: {
                    duration: 150,
                    easing: 'cubic-bezier(.19,1.33,.46,.98)',
                },
            },
            dialogLeaveAnimation: {
                keyframes: [
                    { transform: 'scale(1)', opacity: 1 },
                    { transform: 'scale(0.98)', opacity: 0.5 },
                ],
                options: {
                    duration: 150,
                    easing: 'cubic-bezier(.19,1.33,.46,.98)',
                },
            },
        },
    },
};
